/* First-party cart context for Shopify Flow. No secret or customer identity. */
(function (w, d) {
  'use strict';
  if (w.__smarketOpenAIAttribution || !w.Shopify || w.Shopify.designMode) return;
  var state = w.__smarketOpenAIAttribution = { version: 3, contextVersion: 2, writes: 0, lastWriteOk: false, formWrites: 0 };
  var busy = false, again = false, forceNext = false, lastValue = null, lastWriteAt = 0, timer;
  var attributeName = '__smarket_openai', fieldName = 'attributes[' + attributeName + ']';
  var root = w.Shopify.routes && w.Shopify.routes.root || '/';
  if (root.charAt(0) !== '/' || root.indexOf('//') !== -1) return;
  var endpoint = root + 'cart/update.js';
  function permission() {
    var p = w.Shopify.customerPrivacy;
    try {
      return !!p && p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true && p.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function cookie(name) {
    var entries = d.cookie.split(';');
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i].trim();
      if (entry.indexOf(name + '=') === 0) {
        try { return decodeURIComponent(entry.slice(name.length + 1)); } catch (_) { return ''; }
      }
    }
    return '';
  }
  function valid(value) {
    if (!value || value.length > 4096) return false;
    for (var i = 0; i < value.length; i++) {
      var n = value.charCodeAt(i); if (n < 32 || n === 127) return false;
    }
    return true;
  }
  function context() {
    // A denied/unavailable state clears this integration's prior cart context.
    if (!permission()) return '';
    var oppref = cookie('__oppref'), obref = cookie('__obref');
    if (!valid(oppref) && !valid(obref)) return '';
    var value = { version: 2, measurementAllowed: true, consentSource: 'shopify_storefront_customer_privacy' };
    if (valid(oppref)) value.oppref = oppref;
    if (valid(obref)) value.obref = obref;
    return JSON.stringify(value);
  }
  function encoded(signature) {
    if (!signature) return '';
    var value = JSON.parse(signature);
    value.observedAt = new Date().toISOString();
    return JSON.stringify(value);
  }
  // Cart POSTs carry the current context in the same submission as checkout.
  // Do not intercept payment buttons, delay navigation or modify product forms.
  function isCartForm(form) {
    if (!form || form.tagName !== 'FORM' || String(form.method).toLowerCase() !== 'post') return false;
    try {
      var url = new URL(form.action, w.location.href);
      return url.origin === w.location.origin && url.pathname.replace(/\/$/, '') === (root + 'cart').replace(/\/$/, '');
    } catch (_) { return false; }
  }
  function prepareForm(form) {
    if (!isCartForm(form)) return;
    var field = form.querySelector('input[data-smarket-openai-context]');
    if (!field) {
      field = d.createElement('input'); field.type = 'hidden'; field.name = fieldName;
      field.setAttribute('data-smarket-openai-context', ''); form.appendChild(field);
    }
    field.value = encoded(context()); state.formWrites++;
  }
  function prepareForms() {
    d.querySelectorAll('form').forEach(prepareForm);
  }
  async function sync(force) {
    if (force) forceNext = true;
    if (busy) { again = true; return; }
    var signature = context();
    var refresh = !!signature && Date.now() - lastWriteAt >= 15 * 60 * 1000;
    if (signature === lastValue && !forceNext && !refresh) return;
    forceNext = false;
    if (signature === '' && lastValue === null) {
      // A previous page/session may have saved context. Clearing is intentional.
      state.lastReason = 'clear_unavailable_or_denied_context';
    }
    var value = encoded(signature);
    var attributes = { __smarket_openai: value };
    busy = true; state.lastWriteOk = false;
    try {
      var response = await w.fetch(endpoint, {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes }),
        signal: AbortSignal.timeout(5000)
      });
      if (!response.ok) throw new Error('Cart update failed');
      // Never log the cart response or attribution values.
      lastValue = signature; lastWriteAt = Date.now(); state.writes++; state.lastWriteOk = true;
      state.lastReason = value ? 'storefront_permission_recorded' : 'context_cleared';
    } catch (_) { state.lastReason = 'cart_update_failed'; }
    finally { busy = false; if (again) { again = false; sync(); } }
  }
  function schedule(refresh) {
    prepareForms();
    if (refresh) forceNext = true;
    w.clearTimeout(timer); timer = w.setTimeout(function () { sync(); }, 100);
  }
  d.addEventListener('visitorConsentCollected', function () { prepareForms(); sync(true); });
  ['cart:update', 'cart:updated', 'cart:refresh'].forEach(function (name) {
    d.addEventListener(name, function () { schedule(true); });
  });
  d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'visible') schedule(true); });
  d.addEventListener('submit', function (event) { prepareForm(event.target); }, true);
  d.addEventListener('formdata', function (event) {
    if (isCartForm(event.target) && event.formData) event.formData.set(fieldName, encoded(context()));
  }, true);
  w.addEventListener('pageshow', function () { schedule(true); });
  w.addEventListener('pagehide', function () { sync(true); });
  function ready() {
    prepareForms();
    // Allow the already-installed OpenAI SDK to create its own browser references.
    [0, 500, 1500, 4000, 10000].forEach(function (delay) { w.setTimeout(function () { sync(); }, delay); });
    // SDK references or permission may appear after the initial loading window.
    // Retry failures and refresh long-lived carts without repeatedly writing unchanged context.
    w.setInterval(function () { if (d.visibilityState !== 'hidden') { prepareForms(); sync(); } }, 15000);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
})(window, document);
